(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-tr', {
            parent: 'entity',
            url: '/service-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-tr/service-trs.html',
                    controller: 'Service_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-tr-detail', {
            parent: 'service-tr',
            url: '/service-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.service_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-tr/service-tr-detail.html',
                    controller: 'Service_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Service_tr', function($stateParams, Service_tr) {
                    return Service_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-tr-detail.edit', {
            parent: 'service-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-tr.new', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Service', function($stateParams, $state, $uibModal, Service) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                service: Service.get({id:$stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities',null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('service-tr.edit', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-dialog.html',
                    controller: 'Service_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null, { reload: 'registryEntities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-tr.delete', {
            parent: 'registryEntities',
            url: '/service-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-tr/service-tr-delete-dialog.html',
                    controller: 'Service_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Service_tr', function(Service_tr) {
                            return Service_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
